// extracted by mini-css-extract-plugin
export default {"modalHead":"ChangePropertyStatusModal_modalHead__YE5e4","text":"ChangePropertyStatusModal_text__e5B7p","modalBody":"ChangePropertyStatusModal_modalBody__v2-kF"};